export const PDFExportTypes = {
    clean: "[PDFExport] clean",
    loadOne: "[PDFExport] loadOne",
    removeOne: "[PDFExport] removeOne",
    toggleButton: "[PDFExport] toggleButton",
    setTemplateKey: "[PDFExport] setTemplateKey",
};
